import { Stack } from "@mui/material";
import { I18N_NAMESPACES } from "@src/appV2/i18n/constants";
import { useTu } from "@src/appV2/i18n/useTu";
import {
  isValidTextArea,
  ValidatedTextArea,
} from "@src/appV2/redesign/components/ValidatedTextArea";
import { type UseModalState } from "@src/lib/ui-react";
import { useEffect, useState } from "react";

import { Dialog } from "../../components/Dialog";
import { DialogFooter } from "../../components/DialogFooter";

interface EditPolicyDialogProps {
  fieldName: string;
  initialContent: string;
  isSaving: boolean;
  maxCharacters: number;
  minCharacters: number;
  modalState: UseModalState;
  title: string;
  onSave: (content: string) => void;
}

export function EditPolicyDialog({
  fieldName,
  initialContent,
  isSaving,
  maxCharacters,
  minCharacters,
  modalState,
  title,
  onSave,
}: EditPolicyDialogProps) {
  const { tu } = useTu(I18N_NAMESPACES.settings);
  const [content, setContent] = useState(initialContent);

  useEffect(() => {
    setContent(initialContent);
  }, [initialContent, modalState.modalIsOpen]);

  const isValid = isValidTextArea({ value: content, minCharacters, maxCharacters });

  return (
    <Dialog
      modalState={modalState}
      title={title}
      width={500}
      footerContent={
        <DialogFooter
          primaryAction={{
            label: tu("Save"),
            disabled: !isValid || isSaving,
            isLoading: isSaving,
            onClick: () => {
              onSave(content);
            },
          }}
          secondaryAction={{
            label: tu("Cancel"),
            onClick: modalState.closeModal,
          }}
        />
      }
    >
      <Stack spacing={2}>
        <ValidatedTextArea
          fullWidth
          fieldName={fieldName}
          maxCharacters={maxCharacters}
          minCharacters={minCharacters}
          minRows={6}
          maxRows={12}
          value={content}
          placeholder={tu("Enter {{fieldName}}...", {
            values: { fieldName: fieldName.toLowerCase() },
          })}
          onChange={setContent}
        />
      </Stack>
    </Dialog>
  );
}
